{
     "EN": {
    "headingValue": "Let's get started!",
    "buttonValue": "Next",
    "enterEmail": "Please enter your email address to see if you've already registered with us."
  },
  "VN_VIE": {
    "headingValue": "Xin chào",
    "buttonValue": "Tiếp theo",
    "enterEmail": "Vui lòng nhập địa chỉ email của bạn để xem bạn đã đăng ký với chúng tôi chưa."
  },
  "ID_IND": {
    "headingValue": "Mari kita mulai!",
    "buttonValue": "Berikutnya",
    "enterEmail": "Silakan masukkan alamat email Anda untuk melihat apakah Anda sudah terdaftar."
  },
  "KH_KHM": {
    "headingValue": "សូមស្វាគមន៍!",
    "buttonValue": "បន្ទាប់",
    "enterEmail": "សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់អ្នកដើម្បីពិនិត្យមើលថាតើអ្នកបានចុះឈ្មោះជាមួយយើងរួចហើយឬនៅ។"
  },
  "TH_THA": {
    "headingValue": "มาเริ่มกันเลย!",
    "buttonValue": "ถัดไป",
    "enterEmail": "กรุณาใส่อีเมลของคุณเพื่อตรวจสอบว่าคุณได้ลงทะเบียนกับเราหรือยัง"
  },
  "KR_KOR": {
    "headingValue": "시작해 볼까요!",
    "buttonValue": "다음",
    "enterEmail": "귀하의 이전 기록 확인을 위해 이메일 주소를 입력해 주세요."
  },
  "TR_TUR": {
    "headingValue": "Merhaba, Hoş Geldiniz!",
    "buttonValue": "İlerle",
    "enterEmail": "Daha önce kayıt olup olmadığınızı kontrol etmek için lütfen e-posta adresinizi girin."
  },
  "SA_ARA": {
    "headingValue": "أهلا ومرحبا",
    "buttonValue": "التالي",
    "enterEmail": "يرجى إدخال عنوان بريدك الإلكتروني لمعرفة ما إذا كنت قد سجلت معنا بالفعل."
  },
  "TW_CHI": {
    "headingValue": "現在就開始吧！",
    "buttonValue": "下一頁",
    "enterEmail": "請輸入你的電子信箱以查看是否已經註冊帳戶。"
  },
  "HK_CHI": {
    "headingValue": "我們開始吧！",
    "buttonValue": "下一頁",
    "enterEmail": "請輸入你的電郵地址以查看是否經已註冊。"
  },
  "HK_ZK": {
    "headingValue": "我们开始吧！",
    "buttonValue": "下一页",
    "enterEmail": "请输入你的电邮地址以查看是否经已注册。"
  },
  "IR_FAS": {
    "headingValue": "درود و خوش آمد",
    "buttonValue": "بعد",
    "enterEmail": "لطفاً آدرس ایمیل خود را وارد کنید تا ببینیم آیا قبلاً نزد ما ثبت‌نام کرده‌اید یا خیر."
  },
  "CN_CHI": {
    "headingValue": "我們開始吧！",
    "buttonValue": "下一頁",
    "enterEmail": "請輸入你的電郵地址以查看是否經已註冊。"
  },
  "CN_ZK": {
    "headingValue": "我们开始吧！",
    "buttonValue": "下一页",
    "enterEmail": "请输入你的电邮地址以查看是否经已注册。"
  }
}